// extracted by mini-css-extract-plugin
export default {"kie":"palletes_kie__BgU9s","darkAge":"palletes_darkAge__OHty+","sakuramancer":"palletes_sakuramancer__wVybP"};